{
  "el": {
    "company": {
      "actions": {
        "changeCompany": "Αλλαγή εταιρείας",
        "searchCompany": "Αναζήτηση εταιρείας"
      },
      "attributes": {
        "address": "Διεύθυνση",
        "email_address": "Email",
        "iban": "IBAN",
        "language": "Γλώσσα",
        "name": "Όνομα εταιρείας",
        "phone": "Τηλέφωνο",
        "subdomain": "Υποτομέας",
        "vat": "ΦΠΑ"
      },
      "labels": {
        "company": "Εταιρεία",
        "contact": "Επαφή",
        "contacts": "Επαφές",
        "language": "Αυτή είναι η προεπιλεγμένη γλώσσα της εταιρείας για τη σελίδα σύνδεσης, τους πελάτες και τα μέλη της ομάδας σου.",
        "or": "Ή"
      },
      "validation": {
        "contactAlreadyExist": "Η επαφή υπάρχει ήδη. Επίλεξέ την από τη λίστα.",
        "mustBeEmailAddress": "Απαιτείται έγκυρη διεύθυνση email",
        "needName": "Το όνομα είναι υποχρεωτικό"
      }
    }
  }
}
